import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const MasterDataFleetsVehicles = () => {
	return <PlaceholderView pageType={PageType.MasterDataFleetsVehicles} text="Fleets & Vehicles" />;
};

export default MasterDataFleetsVehicles;
